/**
 * Build a JSON-LD <script type="application/ld+json"> entry for useHead().
 * The stable `key` lets unhead dedupe the script across client-side navigation.
 */
export function jsonLdScript (schema: Record<string, unknown>, key: string) {
    return {
        // unhead v3 narrowed script.type to a literal union, so widen-to-string must be prevented.
        type: 'application/ld+json' as const,
        key,
        // unhead v2 renders a script's text content from `innerHTML` (not `children`,
        // which would be emitted as an HTML attribute and break the JSON-LD).
        innerHTML: JSON.stringify(schema),
    }
}
